import { createContext, type ReactNode, useContext } from "react";
import type { GlassProminence } from "./types";
const GlassScopeContext = createContext<GlassProminence | null>(null);

/**
 * Sets the glass level for everything glass inside it, the way `Theme` sets
 * light or dark: wrap a photo in `prominence="clear"` and its chips and
 * buttons go clear. The nearest scope wins.
 */
export const GlassScope = ({
  prominence,
  children
}: {
  prominence: GlassProminence;
  children: ReactNode;
}) => <GlassScopeContext.Provider value={prominence} data-sentry-element="GlassScopeContext.Provider" data-sentry-component="GlassScope" data-sentry-source-file="GlassScope.tsx">
    {children}
  </GlassScopeContext.Provider>;
export const useGlassProminence = (roleDefault: GlassProminence) => useContext(GlassScopeContext) ?? roleDefault;